import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  // Load cart from localStorage once
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);
  }, []);

  // Save cart whenever it changes ✅
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // Add item to cart
  const addToCart = (item) => {
    setCart((prev) => {
      const existing = prev.find((p) => p.productId === item.productId);
      if (existing) {
        return prev.map((p) =>
          p.productId === item.productId
            ? {
                ...p,
                quantity: Number(p.quantity || 1) + Number(item.quantity || 1),
              }
            : p
        );
      }
      return [...prev, { ...item, quantity: Number(item.quantity) || 1 }];
    });
  };

  // Remove one unit or whole product
  const removeFromCart = (productId) => {
    setCart((prev) =>
      prev
        .map((item) =>
          item.productId === productId
            ? { ...item, quantity: Number(item.quantity) - 1 }
            : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  // Clear all items
  const clearCart = () => {
    setCart([]);
    localStorage.removeItem("cart");
  };

  // Total count
  const totalItems = cart.reduce(
    (sum, item) => sum + Number(item.quantity || 1),
    0
  );

  return (
    <CartContext.Provider
      value={{ cart, addToCart, removeFromCart, clearCart, totalItems }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}